import React, { useState, useEffect } from 'react';
import api from "../../../../../../services/api";

import AddMotivoEncerramento from './AddMotivoEncerramento';
import List from './List';
import { Button } from "reactstrap";


export default ({ notify, empresa, isActive, setHeaderExtra, setOnNovo, ...props }) => {
    const [motivosEncerramentos, setMotivosEquipes] = useState([]);
    const [showAddMotivoEncerramento, setShowAddMotivoEncerramento] = useState(false);

    useEffect(() => {
        if (isActive && setOnNovo) {
            setOnNovo(() => () => setShowAddMotivoEncerramento(true));
            return () => setOnNovo(null);
        }
    }, [isActive, setOnNovo]);

    useEffect(() => {
        if (motivosEncerramentos.length === 0) loadMotivosEncerramentos();
    }, [empresa])

    async function loadMotivosEncerramentos() {
        try {
            const response = await api.get(`/common/empresas/${empresa.id}/motivos-encerramentos`);
            setMotivosEquipes(await response.data);
        } catch (error) {
            console.error(error);
            notify('danger', 'Não foi possível carregar os motivos');
        }
    }

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center'
                }}
            >
                <AddMotivoEncerramento
                    empresa={empresa}
                    motivosEncerramentos={motivosEncerramentos.map(motivoEncerramento => motivoEncerramento.id)}
                    onSuccess={loadMotivosEncerramentos}
                    show={showAddMotivoEncerramento}
                    notify={notify}
                    close={() => setShowAddMotivoEncerramento(false)}
                />
            </div>
            <List
                motivosEncerramentos={motivosEncerramentos}
                empresa={empresa}
                reload={loadMotivosEncerramentos}
                notify={notify}
            />
        </>
    );
}
